import { useState, useEffect, useRef } from 'react';
import { getSystemTheme } from '@/utils/helpers';

export const useTheme = (initialTheme = 'auto') => {
  const [themeMode, setThemeMode] = useState(initialTheme);
  const [resolvedTheme, setResolvedTheme] = useState('light');
  const userToggled = useRef(false);

  useEffect(() => {
    if (!userToggled.current) {
      setThemeMode(initialTheme);
    }
  }, [initialTheme]);

  useEffect(() => {
    const resolveTheme = () => {
      if (themeMode === 'auto') {
        return getSystemTheme();
      }
      return themeMode;
    };

    setResolvedTheme(resolveTheme());

    if (themeMode === 'auto') {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

      const handleChange = (e) => {
        setResolvedTheme(e.matches ? 'dark' : 'light');
      };

      mediaQuery.addEventListener('change', handleChange);

      return () => {
        mediaQuery.removeEventListener('change', handleChange);
      };
    }
  }, [themeMode]);

  const toggleTheme = () => {
    userToggled.current = true;
    setThemeMode((prev) => {
      if (prev === 'auto') {
        return resolvedTheme === 'light' ? 'dark' : 'light';
      }
      return prev === 'light' ? 'dark' : 'light';
    });
  };

  return {
    theme: resolvedTheme,
    themeMode,
    setThemeMode,
    toggleTheme
  };
};
